import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FaTiktok, FaFacebook, FaInstagram } from 'react-icons/fa';

const socialLinks = [
    { href: 'https://www.tiktok.com/@blueboardesk8', icon: FaTiktok, 'aria-label': 'TikTok' },
    { href: 'https://www.facebook.com/profile.php?id=61570467006347', icon: FaFacebook, 'aria-label': 'Facebook' },
    { href: 'https://www.instagram.com/blueboardtlv/', icon: FaInstagram, 'aria-label': 'Instagram' },
];

const SideSocialLinks = () => {
    const [isVisible, setIsVisible] = useState(true);
    const location = useLocation();

    const onSpecialPage = location.pathname === '/' || location.pathname === '/about';

    useEffect(() => {
        const handleScroll = () => {
            const footer = document.getElementById('main-footer');
            if (footer) {
                const footerPosition = footer.getBoundingClientRect().top;
                const windowHeight = window.innerHeight;
                if (footerPosition < windowHeight) {
                    setIsVisible(false);
                } else {
                    setIsVisible(true);
                }
            }
        };
        
        // Always run the scroll effect
        window.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Conditionally render the component's JSX, not the hooks.
    if (onSpecialPage) {
        return null;
    }

    return (
        <div 
            className={`fixed left-4 top-1/2 -translate-y-1/2 z-50 transition-opacity duration-300 ${isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        >
            <div className="flex flex-col gap-4">
                {socialLinks.map((link, index) => (
                    <a
                        key={index}
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={link['aria-label']}
                        className="text-white bg-black bg-opacity-50 p-2 md:p-3 rounded-full hover:bg-blue-600 transition-colors"
                    >
                        <link.icon className="h-5 w-5 md:h-6 md:w-6" />
                    </a>
                ))}
            </div>
        </div>
    );
};

export default SideSocialLinks; 